interface SchemaOrgProps {
  type: "Organization" | "WebSite" | "WebPage" | "BreadcrumbList" | "Article" | "FAQPage";
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  if (typeof window === "undefined") return null;

  const id = `schema-${type}`;
  const existing = document.getElementById(id);
  if (existing) existing.remove();

  const script = document.createElement("script");
  script.id = id;
  script.type = "application/ld+json";
  const schema = {
    "@context": "https://schema.org",
    "@type": type,
    ...data,
  };
  script.textContent = JSON.stringify(schema);
  document.head.appendChild(script);

  return null;
}